// Deterministic avatar color picker.
// Returns one of 6 preset HSL color strings based on a seed (e.g. user.id).
const PALETTE = [
  'hsl(190 90% 50%)', // cyan
  'hsl(160 60% 45%)', // mint
  'hsl(20 85% 60%)',  // peach
  'hsl(265 55% 60%)', // lavender
  'hsl(40 90% 55%)',  // amber
  'hsl(345 75% 60%)', // rose
];

export const getAvatarColor = (seed: string): string => {
  if (!seed) return PALETTE[0];
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  }
  const idx = Math.abs(hash) % PALETTE.length;
  return PALETTE[idx];
};
